import { ACCOUNT_CODE_CONFIRMED_ACTION, ACCOUNT_CODE_FAILED_ACTION } from "../actions/actionTypes";


const initialState = {
    list: [],
    data: {},
    errorMessage: '',
    successMessage: '',
    showLoading: false,
};

export function AccountCodeReducer(state = initialState, action) {
    if (action.type === ACCOUNT_CODE_CONFIRMED_ACTION) {
        return {
            ...state,
            list: action.payload,
            errorMessage: '',
            successMessage: 'account codes fetched successfully',
            showLoading: false,
        };
    }  else if (
        action.type === ACCOUNT_CODE_FAILED_ACTION
    ) {

        return {
            ...state,
            errorMessage: action.payload,
            successMessage: '',
            showLoading: false,
        };
    } else {
        return state;
    }
}
